/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Widget_Today_LiveInputs */

const en_us2_native_release_widget_today_live = /** @type {(inputs: Native_Release_Widget_Today_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout in progress`)
};

const pt_br2_native_release_widget_today_live = /** @type {(inputs: Native_Release_Widget_Today_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino em andamento`)
};

const pt_pt2_native_release_widget_today_live = /** @type {(inputs: Native_Release_Widget_Today_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino em andamento`)
};

/** @type {(inputs: Native_Release_Widget_Today_LiveInputs) => LocalizedString} */
const es_419_native_release_widget_today_live = en_us2_native_release_widget_today_live;

/** @type {(inputs: Native_Release_Widget_Today_LiveInputs) => LocalizedString} */
const fr_fr2_native_release_widget_today_live = en_us2_native_release_widget_today_live;

/** @type {(inputs: Native_Release_Widget_Today_LiveInputs) => LocalizedString} */
const de_de2_native_release_widget_today_live = en_us2_native_release_widget_today_live;

/** @type {(inputs: Native_Release_Widget_Today_LiveInputs) => LocalizedString} */
const it_it2_native_release_widget_today_live = en_us2_native_release_widget_today_live;

/**
* | output |
* | --- |
* | "Workout in progress" |
*
* @param {Native_Release_Widget_Today_LiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_today_live = /** @type {((inputs?: Native_Release_Widget_Today_LiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Today_LiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_today_live(inputs)
	if (locale === "es-419") return es_419_native_release_widget_today_live(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_today_live(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_today_live(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_today_live(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_today_live(inputs)
	return en_us2_native_release_widget_today_live(inputs)
});
export { native_release_widget_today_live as "native-release.widget_today_live" }